import { render } from "./vid.vue?vue&type=template&id=5acd2344&scoped=true"
import script from "./vid.vue?vue&type=script&lang=js"
export * from "./vid.vue?vue&type=script&lang=js"

import "./vid.vue?vue&type=style&index=0&id=5acd2344&lang=sass&scoped=true"

import exportComponent from "C:\\Users\\colin\\Documents\\WebProjects\\cee\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acd2344"]])

export default __exports__